// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttons_wrapper[data-v-6903c22d]{display:flex;width:100%}", "",{"version":3,"sources":["webpack://./resources/client/modules/account/components/CloseAccountModal.vue"],"names":[],"mappings":"AACA,kCACE,YAAA,CACA,UAAF","sourcesContent":["\n.buttons_wrapper {\n  display: flex;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
